import React from 'react'

import Head from 'next/head'

import ClientErrorBoundary from '@/components/error/ClientErrorBoundary'
import { HomeDashboard } from '@/components/home/dashboard'
import { getLayout } from '@/components/layouts/home/Layout'
import { getMetadataFn } from '@/components/seo/DefaultMetadata'

import { type NextPageWithLayout } from '@/types/next'

// Things to add:
// - Industry news tailored to organization
// - Critical actions (e.g. suggested tasks based on news and spending insights)
//   - this will eventually be our bread and butter on the data side, need to get it right
// - Upcoming events (calendar view)
// - Proposal metrics (win rate, efficiency, completion rate)

const HomePage: NextPageWithLayout = () => {
  return (
    <>
      <Head>
        <title>Sweetspot</title>
      </Head>
      <ClientErrorBoundary>
        <HomeDashboard />
      </ClientErrorBoundary>
    </>
  )
}

HomePage.getLayout = getLayout
HomePage.getMetadata = getMetadataFn()

export default HomePage
